import React from "react";
import { Menu } from "semantic-ui-react";
import { Link } from "react-router-dom";

/**
 * header
 */
function Header() {
  return (
    <Menu inverted>
      <Menu.Item header as={Link} to="/">
        {"dpndon"}
      </Menu.Item>
    </Menu>
  );
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js